import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const MIDDLEWARE_URL = process.env.REACT_APP_API_URL;


export default function Archive() {
  const navigate = useNavigate();
  const [invoices, setInvoices] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [modal, setModal] = useState(null);
  const [toast, setToast] = useState(null);
  const [activeTab, setActiveTab] = useState("invoices"); // invoices | stats

  useEffect(() => {
    Promise.all([
      fetch(`${MIDDLEWARE_URL}/archive/invoices`).then(r => r.json()).catch(() => ({ invoices: [] })),
      fetch(`${MIDDLEWARE_URL}/archive/statistics`).then(r => r.json()).catch(() => null),
    ]).then(([inv, st]) => {
      setInvoices(inv.invoices || inv || []);
      setStats(st?.statistics || st);
      setLoading(false);
    });
  }, []);

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3500);
  };

  const openAudit = async (num) => {
    setModal({ type: "audit", num, loading: true });
    try {
      const r = await fetch(`${MIDDLEWARE_URL}/archive/invoices/${num}/audit`);
      const data = await r.json();
      setModal({ type: "audit", num, data, loading: false });
    } catch { setModal({ type: "audit", num, data: { error: "Erreur" }, loading: false }); }
  };

  const checkIntegrity = async (num) => {
    setModal({ type: "integrity", num, loading: true });
    try {
      const r = await fetch(`${MIDDLEWARE_URL}/archive/invoices/${num}/integrity`);
      const data = await r.json();
      setModal({ type: "integrity", num, data, loading: false });
    } catch { setModal({ type: "integrity", num, data: { error: "Erreur" }, loading: false }); }
  };

  const downloadXML = async (num) => {
    try {
      const r = await fetch(`${MIDDLEWARE_URL}/archive/download/${num}`);
      const blob = await r.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = `archive_${num}.xml`; a.click();
      URL.revokeObjectURL(url);
      showToast(`XML archivé #${num} téléchargé`);
    } catch { showToast("Erreur téléchargement", "error"); }
  };

  const filtered = (Array.isArray(invoices) ? invoices : []).filter(inv => {
    const q = search.toLowerCase();
    return !q || String(inv.num_facture || inv.NumFacture || "").includes(q) ||
      String(inv.uuid_dss || "").toLowerCase().includes(q) ||
      String(inv.statut || inv.status || "").toLowerCase().includes(q);
  });

  const statutColor = (s) => {
    if (!s) return { color: "#6b7280", bg: "#f3f4f6" };
    s = s.toUpperCase();
    if (s === "ACCEPTED" || s === "ACCEPTEE") return { color: "#16a34a", bg: "#dcfce7" };
    if (s === "REJECTED" || s === "REJETEE") return { color: "#dc2626", bg: "#fee2e2" };
    if (s === "PENDING" || s === "EN_ATTENTE") return { color: "#d97706", bg: "#fef3c7" };
    if (s === "SENT" || s === "ENVOYEE") return { color: "#2563eb", bg: "#dbeafe" };
    return { color: "#6b7280", bg: "#f3f4f6" };
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc", fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      {/* NAVBAR */}
      <nav style={{
        background: "#fff", borderBottom: "1px solid #e2e8f0", padding: "0 32px",
        display: "flex", alignItems: "center", justifyContent: "space-between", height: 64,
        position: "sticky", top: 0, zIndex: 100, boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 32 }}>
          <div onClick={() => navigate("/home")} style={{ cursor: "pointer" }}>
            <span style={{ fontSize: 22, fontWeight: 800, background: "linear-gradient(135deg,#6366f1,#8b5cf6)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>⚡ LOGIMES</span>
          </div>
          <div style={{ display: "flex", gap: 4 }}>
            {[["🏠", "Accueil", "/home"], ["👥", "Clients", "/clients"], ["🧾", "Factures", "/factures"], ["📦", "Archive", "/archive"], ["📊", "Dashboard", "/dashboard"]].map(([icon, label, path]) => (
              <button key={path} onClick={() => navigate(path)} style={{
                padding: "6px 14px", borderRadius: 8, border: "none", cursor: "pointer", fontSize: 13, fontWeight: 500,
                background: path === "/archive" ? "#f0fdf4" : "transparent",
                color: path === "/archive" ? "#16a34a" : "#64748b",
              }}>{icon} {label}</button>
            ))}
          </div>
        </div>
        <button onClick={() => { localStorage.removeItem("token"); navigate("/"); }} style={{
          padding: "8px 18px", borderRadius: 8, border: "1.5px solid #e2e8f0", background: "#fff",
          color: "#64748b", fontSize: 13, fontWeight: 500, cursor: "pointer"
        }}>Déconnexion</button>
      </nav>

      <div style={{ maxWidth: 1400, margin: "0 auto", padding: "32px 24px" }}>
        <div style={{ marginBottom: 28 }}>
          <h1 style={{ fontSize: 28, fontWeight: 700, color: "#0f172a", margin: 0 }}>📦 Archivage Légal</h1>
          <p style={{ color: "#64748b", margin: "6px 0 0", fontSize: 14 }}>Toutes les factures archivées avec leur UUID ANCE et statut</p>
        </div>

        {/* STATS CARDS */}
        {stats && (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 16, marginBottom: 28 }}>
            {[
              { label: "Total archivées", value: stats.total || 0, color: "#6366f1", icon: "📦" },
              { label: "Acceptées", value: stats.by_status?.ACCEPTED || 0 , color: "#16a34a", icon: "✅" },
              { label: "Rejetées",  value: stats.by_status?.REJECTED || 0, color: "#dc2626", icon: "❌" },
              { label: "En attente",value: stats.by_status?.PENDING  || 0, color: "#d97706", icon: "⏳" },
            ].map(s => (
              <div key={s.label} style={{ background: "#fff", borderRadius: 12, padding: "20px 24px", border: "1px solid #e2e8f0" }}>
                <div style={{ fontSize: 24, marginBottom: 8 }}>{s.icon}</div>
                <div style={{ fontSize: 22, fontWeight: 700, color: s.color }}>{s.value}</div>
                <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>{s.label}</div>
              </div>
            ))}
          </div>
        )}

        {/* TABS */}
        <div style={{ display: "flex", gap: 4, marginBottom: 20, background: "#f1f5f9", padding: 4, borderRadius: 10, width: "fit-content" }}>
          {[["invoices", "📋 Factures archivées"], ["stats", "📊 Statistiques détaillées"]].map(([tab, label]) => (
            <button key={tab} onClick={() => setActiveTab(tab)} style={{
              padding: "8px 20px", borderRadius: 8, border: "none", cursor: "pointer",
              background: activeTab === tab ? "#fff" : "transparent",
              color: activeTab === tab ? "#0f172a" : "#64748b",
              fontWeight: activeTab === tab ? 600 : 400, fontSize: 13,
              boxShadow: activeTab === tab ? "0 1px 3px rgba(0,0,0,.1)" : "none"
            }}>{label}</button>
          ))}
        </div>

        {activeTab === "invoices" && (
          <>
            {/* SEARCH */}
            <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", padding: "14px 20px", marginBottom: 16, display: "flex", gap: 12 }}>
              <div style={{ position: "relative", flex: 1 }}>
                <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#94a3b8" }}>🔍</span>
                <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Rechercher par N° facture, UUID ANCE..."
                  style={{ width: "100%", paddingLeft: 36, paddingRight: 12, height: 38, borderRadius: 8, border: "1.5px solid #e2e8f0", fontSize: 13, outline: "none", background: "#f8fafc", boxSizing: "border-box" }} />
              </div>
              <span style={{ alignSelf: "center", color: "#64748b", fontSize: 13 }}>{filtered.length} résultat(s)</span>
            </div>

            {/* TABLE */}
            <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", overflow: "hidden" }}>
              {loading ? (
                <div style={{ padding: 80, textAlign: "center", color: "#94a3b8" }}><div style={{ fontSize: 32 }}>⏳</div><div style={{ marginTop: 12 }}>Chargement...</div></div>
              ) : (
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                  <thead>
                    <tr style={{ background: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
                      {["N° Facture", "UUID ANCE", "Date Archivage", "Statut ANCE", "Actions"].map(h => (
                        <th key={h} style={{ padding: "12px 16px", textAlign: "left", fontWeight: 600, color: "#374151", fontSize: 12, textTransform: "uppercase", letterSpacing: "0.05em" }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {filtered.length === 0 ? (
                      <tr><td colSpan={5} style={{ padding: 60, textAlign: "center", color: "#94a3b8" }}>
                        {loading ? "Chargement..." : "Aucune facture archivée"}
                      </td></tr>
                    ) : filtered.map((inv, i) => {
                      const num = inv.num_facture || inv.NumFacture || "—";
                      const uuid = inv.uuid_dss || inv.uuid || "—";
                      const date = inv.date_archivage || inv.DateArchivage;
                      const statut = inv.statut || inv.status || "—";
                      const sc = statutColor(statut);
                      return (
                        <tr key={i} style={{ borderBottom: "1px solid #f1f5f9" }}
                          onMouseEnter={e => e.currentTarget.style.background = "#fafbff"}
                          onMouseLeave={e => e.currentTarget.style.background = ""}>
                          <td style={{ padding: "12px 16px", fontWeight: 700, color: "#6366f1" }}>#{num}</td>
                          <td style={{ padding: "12px 16px", color: "#475569", fontFamily: "monospace", fontSize: 11 }}>
                            {uuid !== "—" ? uuid.substring(0, 36) : "—"}
                          </td>
                          <td style={{ padding: "12px 16px", color: "#64748b" }}>
                            {date ? new Date(date).toLocaleDateString("fr-FR") : "—"}
                          </td>
                          <td style={{ padding: "12px 16px" }}>
                            <span style={{ padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 600, color: sc.color, background: sc.bg }}>
                              {statut}
                            </span>
                          </td>
                          <td style={{ padding: "12px 16px" }}>
                            <div style={{ display: "flex", gap: 6 }}>
                              <Btn onClick={() => openAudit(num)} color="#6366f1">📋 Audit</Btn>
                              <Btn onClick={() => checkIntegrity(num)} color="#0891b2">🔒 Intégrité</Btn>
                              <Btn onClick={() => downloadXML(num)} color="#16a34a">⬇ XML</Btn>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>
          </>
        )}

        {activeTab === "stats" && (
          <FullStats url={MIDDLEWARE_URL} />
        )}
      </div>

      {/* MODAL */}
      {modal && (
        <div onClick={() => setModal(null)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.45)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 16, width: "100%", maxWidth: 760, maxHeight: "85vh", display: "flex", flexDirection: "column", boxShadow: "0 25px 50px rgba(0,0,0,.25)" }}>
            <div style={{ padding: "20px 24px", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h2 style={{ margin: 0, fontSize: 17, fontWeight: 700 }}>
                {modal.type === "audit" ? "📋 Journal d'Audit" : "🔒 Vérification Intégrité"} — #{modal.num}
              </h2>
              <button onClick={() => setModal(null)} style={{ border: "none", background: "none", fontSize: 20, cursor: "pointer", color: "#94a3b8" }}>✕</button>
            </div>
            <div style={{ flex: 1, overflow: "auto", padding: 24 }}>
              {modal.loading ? (
                <div style={{ textAlign: "center", padding: 40, color: "#94a3b8" }}>⏳ Chargement...</div>
              ) : (
                <pre style={{ margin: 0, fontSize: 12, background: "#0f172a", color: "#e2e8f0", padding: 20, borderRadius: 10, overflow: "auto", lineHeight: 1.6 }}>
                  {JSON.stringify(modal.data, null, 2)}
                </pre>
              )}
            </div>
          </div>
        </div>
      )}

      {toast && (
        <div style={{ position: "fixed", bottom: 24, right: 24, zIndex: 300, background: toast.type === "error" ? "#dc2626" : "#16a34a", color: "#fff", padding: "12px 20px", borderRadius: 10, fontSize: 13, fontWeight: 500 }}>
          {toast.type === "error" ? "❌" : "✅"} {toast.msg}
        </div>
      )}
      <style>{`* { box-sizing: border-box; }`}</style>
    </div>
  );
}

function FullStats({ url }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    fetch(`${url}/archive/statistics/full`).then(r => r.json()).then(setData).catch(() => setData({ error: "Non disponible" }));
  }, []);
  return (
    <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", padding: 24 }}>
      <h3 style={{ margin: "0 0 16px", fontSize: 15, fontWeight: 600 }}>📊 Statistiques Complètes</h3>
      {!data ? <div style={{ color: "#94a3b8" }}>Chargement...</div> : (
        <pre style={{ margin: 0, fontSize: 12, background: "#0f172a", color: "#e2e8f0", padding: 20, borderRadius: 10, overflow: "auto", lineHeight: 1.6 }}>
          {JSON.stringify(data, null, 2)}
        </pre>
      )}
    </div>
  );
}

function Btn({ onClick, color, children }) {
  return (
    <button onClick={onClick} style={{
      padding: "5px 10px", borderRadius: 6, fontSize: 12, fontWeight: 500, cursor: "pointer",
      border: `1.5px solid ${color}`, background: "#fff", color,
      transition: "all .15s", whiteSpace: "nowrap"
    }}
      onMouseEnter={e => { e.currentTarget.style.background = color; e.currentTarget.style.color = "#fff"; }}
      onMouseLeave={e => { e.currentTarget.style.background = "#fff"; e.currentTarget.style.color = color; }}>
      {children}
    </button>
  );
}


